var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-section",class:{ '--signup': _vm.signupContainer }},[_c('div',{staticClass:"new-section__header",class:[
      { '-subtype': _vm.subType },
      { '-center': _vm.center },
      { '-left': _vm.left },
      { '-mobile': _vm.mobile },
      { '-purple': _vm.purple },
      { '-black': _vm.black },
      { '-noMargin': _vm.noMargin },
      { useInterFamily: _vm.useInterFamily }
    ],style:(("max-width: " + _vm.maxWidth + "px"))},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }